import PreviewFeedback from '.';
import { RouteType } from '@/lib/route';

const PreviewFeedbackRoutes: RouteType = {
  path: '/preview-feedback/:elearningId/:questionId/:type',
  component: PreviewFeedback,
};

export interface PreviewFeedbackParamType {
  elearningId: string;
  questionId: string;
  type: string;
}

export default PreviewFeedbackRoutes;
